/**
 * Mesečni uključeni limit AI obrade slika po paketu.
 * Uskladiti sa server/utils/aiImageUsage.js — getAiMonthlyLimitForPackage
 */
export const AI_IMAGE_OVERAGE_RSD = 3;

export const AI_IMAGE_MONTHLY_LIMIT = {
  starter: 100,
  standard: 300,
  business: 500,
  premium: 500,
};
